import { useRef as L, useMemo as W } from "react";
import { flattenOptions as E } from "./utils.js";
const p = {
  value: "SELECT_ALL",
  label: "Select all"
};
function g(o = [], n = [], s, r) {
  const v = [p, ...o], c = L(n);
  c.current = n || [];
  const t = W(() => E(o), [o]), d = (i, e) => {
    const { action: l, option: a, removedValue: A } = e, u = a || A;
    if (u && u.value === p.value) {
      if (l === "select-option")
        s(t, e);
      else if (l === "deselect-option") {
        const O = t.filter(
          (h) => r.includes(h.value)
        );
        s(O, e);
      }
    } else {
      if ((l === "deselect-option" || l === "remove-value") && r.includes(u.value))
        return;
      s(i, e);
    }
  }, f = () => c.current.length === t.length, m = (i) => f() || c.current.some(({ value: e }) => e === i.value), S = f() ? t : n;
  return {
    optionsWithSelectAll: v,
    valuesWithSelectAll: S,
    isOptionSelected: m,
    onChangeWithSelectAll: d
  };
}
export {
  p as SelectAllOption,
  g as default
};
